// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"1a2b728d","484":"ca1b0d14","879":"25627a05"}[chunkId] + ".chunk.js";
};